import type { Currency, Promotion, PromotionType } from '@weft/types';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import React from 'react';
import { getPromotionConfigDefaultValue } from '../../../../../hooks/use-promotions-config-default-value';
import { PlanChargesContainer } from '../PlanChargesContainer';

export type PromotionChargeViewProps = {
  promotion: Promotion;
  promotionIndex: number;
  currency: Currency
};

export const PromotionChargeView: React.FC<PromotionChargeViewProps> = ({
  promotion,
  promotionIndex,
  currency,
}) => {
  const { name, description, promotionModel } = promotion;
  const { promotionType, promotionConfiguration } = promotionModel;
  const amount = getPromotionConfigDefaultValue(promotionConfiguration, promotionType);

  return (
    <PlanChargesContainer
      key={promotionIndex}
      className="pt-4 shadow-[0px_10px_24px_0px_rgba(0,0,0,0.03)]"
    >
      <div className='divide-line space-y-8 divide-y'>
        <div className="flex justify-between pb-4">
          <div className="flex flex-col space-x-0.5">
            <p className="text-lg font-medium">
              {name}
            </p>
            {description && (
              <p className="text-base text-[#6F6F6F]">{description}</p>
            )}
          </div>
          <div className="flex flex-col space-x-0.5 text-right">
            <p className="text-placeholder text-sm">Discount</p>
            <p className="text-xl font-medium">
              -
              {generateDiscountViews(amount, promotionType, currency)}
            </p>
          </div>
        </div>
      </div>
    </PlanChargesContainer>
  );
};

const generateDiscountViews = (amount: number, promotionType: PromotionType, currency: Currency) => {
  return promotionType === 'Percentage' ? generatePercentageDiscountView(amount) : generateCreditDiscountView(amount, currency);
};

const generatePercentageDiscountView = (amount: number) => {
  return `${amount}%`;
};

const generateCreditDiscountView = (amount: number, currency: Currency) => {
  return `${getCurrencySymbol(currency)}${amount}`; 
};